import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CAUSE_ABSENT_REASON = {
	name: "OBSERVATION_CAUSE_ABSENT_REASON",
	concept: {
		UNKNOWN: {
			display: {
				"nl-BE": "Oorzaak onbekend",
				"fr-BE": "Cause inconnue",
			},
		},
	},
} as const satisfies CodeSystem;
